import axios from "axios"
import _fuc from '../utils/config.js'
// import qs from "qs";
const axiosRequest = axios.create({
    baseURL:'',
    timeout:30000,
})
// axios.defaults.timeout = 30000;
import { Toast,Dialog  } from "vant"
import {router,getSign,getSign2}  from "../router/routerwechatAuth.js";
// request 拦截器
axiosRequest.interceptors.request.use(
    config => {
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration:0
        });
		/*config.headers['Content-Type'] = '';*/
        // 这里可以自定义一些config 配置



        // if(JSON.parse(sessionStorage.getItem('userInfo'))&&sessionStorage.getItem('nowType')=='qiye'){
        //     config.headers.token = JSON.parse(sessionStorage.getItem('userInfo')).token
        //     // config.headers.token = '4920871d-1272-4d08-9fcc-8ad65fb154c2'
        // }else{
        //     if (sessionStorage.getItem('token')&&sessionStorage.getItem('nowType')=='yezhu') {
        //         config.headers.token = sessionStorage.getItem('token');
        //     }
        // }
        if(JSON.parse(sessionStorage.getItem('userInfo'))){
            config.headers.token = JSON.parse(sessionStorage.getItem('userInfo')).token
            // config.headers.token = '4920871d-1272-4d08-9fcc-8ad65fb154c2'
        }else{
            if (sessionStorage.getItem('token')) {
                config.headers.token = sessionStorage.getItem('token');
            }
        }



        
        return config
        
    },
    
    error => {
        return Promise.reject(error)
    }
)
// response 拦截器
axiosRequest.interceptors.response.use(
    response => {
        Toast.clear();
        // blob类型响应直接返回，不走JSON解析
        if (response.config.responseType === 'blob') {
            return Promise.resolve(response.data);
        }
        const res = response.data
        if (response.status === 200) {
			if(Number(res.code)==0&&res.success){
                sessionStorage.setItem('istokenwork',1)
				return Promise.resolve(res.data||true);
			}else if(Number(res.code)==10002){
                Toast.fail('页面已过期失效，请关闭页面后重新进入公众号')
                sessionStorage.setItem('istokenwork',0)
                // if (process.env.NODE_ENV == "production") {
                //     getSign2()
                // } else if (process.env.NODE_ENV == "development") {
                //     getSign()
                // } 
				return Promise.resolve(false);
			}else if(Number(res.code)==200006){
                sessionStorage.setItem('istokenwork',1)
                return res
            }else if(Number(res.code)==0&&res.msg=='success'){
                return res
            }else if(Number(res.code)==0&&res.data==''&&!res.success){
                return res
            }
            else if(Number(res.code)=='101' && res.message=='用户名密码错误'){
                console.log("zoule 101")
			    Dialog({ message:'提示：'+res.message}).then(() => {
                    router.to('/wuye')
                });
				return Promise.resolve(false);
            }
            else{
                sessionStorage.setItem('istokenwork',1)
			    Dialog({ message:'提示：'+res.message}).then(() => {
                    router.go(-1)
                });
				return Promise.resolve(false);
			}
        } else {
        	return Promise.reject(res);
        }
    },
    error => {
		Toast.clear();
		Dialog({ message:'提示：'+error.response.data.message });
        return Promise.reject(error)
    }
)
//export   { axiosRequest };
export default  axiosRequest;
/* 使用export default时，对应的import语句不需要使用大括号,向外暴露的成员，可以使用任意变量来接收； 
   不使用export default时，对应的import语句需要使用大括号,使用{ }按需接收,如果想换个变量名称接收，可以使用as来起别名,方法名 as  别名*/

/* get请求
this.$axios.get('', {
	params: {}
}).then(res => {});
this.$axios({
	url: '',
	method: 'get',
	params: {}
}).then(res => {}); */

/* 3类post请求
1.post的Content-Type=application/json
this.$axios({
	url: '',
	method: 'post',
	data: {
	}
}).then(res => {
});
this.$axios.post('',{}).then(res=>{})

2.post的application/x-www-form-urlencoded，将对象转为&拼接的参数形式,qs.stringify(obj)或者 new URLSearchParams()
const params = new URLSearchParams();
params.append('param1', 'value1');
this.$axios({
	url: '',
	method: 'post',
	headers: { 'content-type': 'application/x-www-form-urlencoded' },
	data: qs.stringify(data)||params,
}).then(res => {
});

3.post的Content-Type=mulitpart/form-data
let formData = new FormData();
formData.append('username', 'cjjd');
let config = {
	headers: {
		'Content-Type': 'multipart/form-data'
	}
};
this.$axios.post('', formData, config).then(res => {
}) 
*/
